const mockManagement = {
  LABEL_MOCK_MANAGEMENT: 'Mock Management',
  LABEL_AP_BALANCES: 'AP Balances',
  LABEL_ARTICLE_MAPPINGS: 'Article Mappings',
  LABEL_AP_CODE: 'AP Code',
  LABEL_PLIKA_AVAILABLE: 'Plika Available',
  LABEL_SAP_CONSUMED: 'SAP Consumed',
  LABEL_AVAILABLE_BALANCE: 'Available Balance',
  LABEL_ARTICLE_ID: 'Article ID',
  LABEL_ACTIONS: 'Actions',
  LABEL_EDIT: 'Edit',
  LABEL_DELETE: 'Delete',
  LABEL_SAVE: 'Save',
  LABEL_CANCEL: 'Cancel',
  LABEL_REFRESH: 'Refresh',
  LABEL_ADD_MAPPING: 'Add Mapping',
  LABEL_ADD_NEW_MAPPING: 'Add New Mapping',
  LABEL_PLACEHOLDER_ARTICLE_ID: 'e.g., ART-12345',
  LABEL_PLACEHOLDER_AP_CODE: 'e.g., AP1',
  MESSAGE_BALANCE_UPDATED: 'Balance updated successfully',
  MESSAGE_MAPPING_SAVED: 'Mapping saved successfully',
  MESSAGE_MAPPING_DELETED: 'Mapping deleted successfully',
  MESSAGE_ERROR_UPDATE_BALANCE: 'Failed to update balance',
  MESSAGE_ERROR_SAVE_MAPPING: 'Failed to save mapping',
  MESSAGE_ERROR_DELETE_MAPPING: 'Failed to delete mapping',
  MESSAGE_REQUIRED_FIELDS: 'Both fields are required',
  MESSAGE_INVALID_NUMBER: 'Please enter a valid positive number',
  CONFIRM_DELETE_MAPPING: 'Are you sure you want to delete the mapping for',
}

export default mockManagement
